import { useReducer } from 'react';
import { CallWidgetStates } from 'calling-internal-common/widget-status/constants/CallWidgetStates';
import { CallDirection } from 'calling-internal-common/constants/CallDirection';
import * as ActionTypes from '../actions/ActionTypes';
import { HUBSPOT } from 'calling-internal-common/call-provider/constants/ProviderNames';
export const VIEWPORT_WIDTH = 400;
export const VIEWPORT_HEIGHT = 600;
export const initialState = {
  thirdPartyCallStatus: CallWidgetStates.UNINITIALIZED,
  thirdPartyUserAvailable: false,
  thirdPartyIsLoggedIn: false,
  thirdPartyCallDirection: CallDirection.OUTBOUND,
  thirdPartyIsPopupOpen: false,
  dialNumberDetails: undefined,
  isWidgetHidden: true,
  isWidgetMinimized: true,
  // TODO: remove unused attributes from context
  sizeInfo: {
    width: VIEWPORT_WIDTH,
    height: VIEWPORT_HEIGHT
  },
  selectedCallProviderData: {
    name: HUBSPOT
  }
};
export const thirdPartyWidgetDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.UPDATE_CALL_STATUS:
      {
        return Object.assign({}, state, {
          thirdPartyCallStatus: action.payload
        });
      }
    case ActionTypes.UPDATE_CALL_DIRECTION:
      {
        return Object.assign({}, state, {
          thirdPartyCallDirection: action.payload
        });
      }
    case ActionTypes.LOGGED_IN:
      {
        return Object.assign({}, state, {
          thirdPartyIsLoggedIn: true
        });
      }
    case ActionTypes.LOGGED_OUT:
      {
        return Object.assign({}, state, {
          thirdPartyIsLoggedIn: false
        });
      }
    case ActionTypes.USER_AVAILABLE:
      {
        return Object.assign({}, state, {
          thirdPartyUserAvailable: true
        });
      }
    case ActionTypes.USER_UNAVAILABLE:
      {
        return Object.assign({}, state, {
          thirdPartyUserAvailable: false
        });
      }
    case ActionTypes.UPDATE_WIDGET_DETAILS:
      {
        const payload = action.payload;
        const newState = {};
        if (!payload) return state;
        if (payload.callStatus) {
          if (payload.callStatus === CallWidgetStates.INCOMING_INBOUND_CALL) {
            newState.thirdPartyCallDirection = CallDirection.INBOUND;
          }
          if (payload.callStatus === CallWidgetStates.INITIALIZING_OUTBOUND_CALL) {
            newState.thirdPartyCallDirection = CallDirection.OUTBOUND;
          }
          newState.thirdPartyCallStatus = payload.callStatus;
        }
        if (payload.isLoggedIn !== undefined) {
          newState.thirdPartyIsLoggedIn = payload.isLoggedIn;
        }
        if (payload.userAvailable !== undefined) {
          newState.thirdPartyUserAvailable = payload.userAvailable;
        }
        if (payload.isPopupOpen !== undefined) {
          newState.thirdPartyIsPopupOpen = payload.isPopupOpen;
        }
        if (payload.dialNumberDetails !== undefined) {
          newState.dialNumberDetails = payload.dialNumberDetails;
        }
        if (payload.sizeInfo) {
          const height = payload.sizeInfo.height;
          const width = payload.sizeInfo.width;
          newState.sizeInfo = {
            height: height || state.sizeInfo.height,
            width: width || state.sizeInfo.width
          };
        }
        if (payload.selectedCallProviderData) {
          newState.selectedCallProviderData = payload.selectedCallProviderData;
        }
        return Object.assign({}, state, newState);
      }
    case ActionTypes.REPLACE_WIDGET_DETAILS:
      {
        return Object.assign({}, state, action.payload);
      }
    case ActionTypes.RESET_WIDGET_DETAILS:
      {
        return initialState;
      }
    case ActionTypes.RESET_REMOTE_CONNECTION:
      {
        if (state.selectedCallProviderData.usesCallingWindow) {
          return initialState;
        }
        return state;
      }
    default:
      return state;
  }
};
export const useThirdPartyWidgetDetailsReducer = () => useReducer(thirdPartyWidgetDetailsReducer, initialState);